import { useMemo } from "react";
import { useQuery } from "react-query";
import { format, parseISO } from "date-fns";

import { fetchClient } from "../../../api/fetching";
import { mlsGetMatches } from "../../../api/variables";
import { getFirstDateOfMonth, getLastDateOfMonth } from "../../../../mls-match-list/utils";
import { useReactAppState } from "../../../containers/utils";
import { isAllOptionSelected } from "../../../../mls-match-list/utils";


function useMLSCalendarMatches({
    seasonSportecId,
    competitionSportecId,
    clubSportecId,
    activeMonth
}) {
    const { apiList } = useReactAppState();

    const { from, to, yearMatchesEndPoint } = useMemo(() => {
        const from = format(getFirstDateOfMonth(activeMonth), 'yyyy-MM-dd');
        const to = format(getLastDateOfMonth(activeMonth), 'yyyy-MM-dd');

        const yearMatchesEndPoint = mlsGetMatches({
            seasonSportecId,
            from,
            to,
            competitionSportecId: isAllOptionSelected(competitionSportecId) ? null : competitionSportecId,
            clubSportecId: isAllOptionSelected(clubSportecId) ? null : clubSportecId,
        });

        return { from, to, yearMatchesEndPoint };
    }, [activeMonth]);

    return useQuery({
        queryKey: ["mls-matches-date-range", [
            from,
            to,
            competitionSportecId,
            clubSportecId,
        ]],
        queryFn: () => fetchClient({ endpoint: yearMatchesEndPoint, apiURL: apiList?.statsAPI }),
        select: (data) => {
            const matches = data?.schedule;
            const matchesByDate = new Map(matches?.map(match => [format(parseISO(match.planned_kickoff_time), 'yyyy-MM-dd'), match]));

            return matchesByDate;
        },
        enabled: !!activeMonth,
        staleTime: Infinity,
        retry: false,
    });
}

export default useMLSCalendarMatches;